module.exports = __webpack_public_path__ + "media/audio24.106f4dce.mp3";